import { getPublicRecipientVendorList } from 'src/clients';
import useSWR from 'swr';
import BANKS from './banks.json';

type BankSource = { bankName: string; bankCode: string };

// TODO: Make this a shared hook, replacing useBankData to get bank options.
export const useRecipientVendor = () => {
  const { data = BANKS } = useSWR(
    `bank/v1/disbursement`,
    async () => {
      const response = await getPublicRecipientVendorList();
      return (
        response.data.data?.map(i => ({
          bankCode: i.bank_code,
          bankName: i.bank_name,
        })) ?? BANKS
      );
    },
    {
      revalidateOnMount: true,
      revalidateIfStale: false,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    },
  );

  const bankOptions = data.map((item: BankSource) => ({
    label: item.bankName,
    value: item.bankCode,
  }));

  const ewalletOptions = data
    .filter((bank: BankSource) => Number.isNaN(parseInt(bank.bankCode)))
    .map((wallet: BankSource) => wallet.bankCode);

  const getBankName = (bankCode: string) => {
    for (const bank of data) {
      if (bank.bankCode.toLowerCase() === bankCode.toLowerCase()) {
        return bank.bankName;
      }
    }
    return null;
  };

  const isBankAvailable = (bankName: string) => {
    for (const bank of data) {
      if (bank.bankName === bankName) {
        return true;
      }
    }
    return false;
  };

  return {
    bankOptions,
    ewalletOptions,
    getBankName,
    isBankAvailable,
  };
};
